import Isotope from "isotope-layout";

export default class FilterContent {
    constructor(element) {
        // Basics Variables
        this.element = element;
        this.grid = this.element.querySelector('[data-content-grid]');

        if(this.element.querySelector('[data-filter-container]'))
        this.filterContainer = this.element.querySelector('[data-filter-container]');
        
        // Declare the Options
        this.options = {
            itemSelector: ".content-grid-item",
            masonry: {
                percentPosition: true,
                gutter: 24,
            },
        };
        
        // Call Init Function
        this.init();
    }
    
    init() {
        // Initiate The Isotope Grid
        this.isotopeGrid = new Isotope(this.grid, this.options);

        // Set The Filters
        if(this.filterContainer) {
            const filters = this.filterContainer.querySelectorAll('[data-filter]')   
            for(let i = 0;i<filters.length;i++) {
                filters[i].addEventListener("click", () => {
                    const filterSlug = filters[i].dataset.filter;
                    const filterValue = filterSlug === '*' ? '*' : `[data-content-categories*="${filterSlug}"]`;

                    for(let fI = 0;fI<filters.length;fI++)
                        filters[fI].classList.remove("active");
                    filters[i].classList.add("active");

                    this.isotopeGrid.arrange({ filter: filterValue });

                    // Items hidden by the previous filter could not be measured
                    if(this.readMoreItems.length) this.refreshReadMore();
                });
            }
        }

        // Set The Read More
        this.readMoreItems = this.grid.querySelectorAll('[data-readmore]');
        if(this.readMoreItems.length) this.initReadMore();
    }

    initReadMore() {
        for(let i = 0;i<this.readMoreItems.length;i++) {
            const item = this.readMoreItems[i];
            const toggle = item.querySelector('[data-readmore-toggle]');

            toggle.addEventListener("click", () => {
                const expanded = !item.classList.contains("is-expanded");
                this.setReadMoreState(item, expanded);

                // Bring the card back into view when collapsing a long text
                if(!expanded && item.getBoundingClientRect().top < 0)
                    item.scrollIntoView({ block: "start" });

                this.isotopeGrid.layout();
            });
        }

        this.refreshReadMore();

        // Card heights change once fonts / iframes are loaded and when the columns change
        if(document.fonts) document.fonts.ready.then(() => this.refreshReadMore());
        window.addEventListener("load", () => this.refreshReadMore());

        let resizeTimeout;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => this.refreshReadMore(), 150);
        });
    }

    refreshReadMore() {
        for(let i = 0;i<this.readMoreItems.length;i++) {
            const item = this.readMoreItems[i];
            const content = item.querySelector('[data-readmore-content]');
            const toggle = item.querySelector('[data-readmore-toggle]');
            const expanded = item.classList.contains("is-expanded");

            // Measure in the collapsed state, then restore
            item.classList.remove("is-expanded");
            const overflows = content.scrollHeight > content.clientHeight + 1;
            if(expanded) item.classList.add("is-expanded");

            item.classList.toggle("is-clamped", overflows);
            toggle.hidden = !overflows;
        }

        this.isotopeGrid.layout();
    }

    setReadMoreState(item, expanded) {
        const toggle = item.querySelector('[data-readmore-toggle]');

        item.classList.toggle("is-expanded", expanded);
        toggle.setAttribute("aria-expanded", expanded);
        toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
    }
}